import React from "react";
import MainBg from "../components/Mainbg";
import Loading from "../components/loading";
import { Link } from "react-router-dom";
import downloadapp from "../assets/images/download-app.png";
import googleapp from "../assets/images/google-app.png";
import appleapp from "../assets/images/apple-app.png";

const AppDownload = () => {

    return (
        <>
            <MainBg>
                <img src={downloadapp} className="h-72 m-auto" />
                <h1 className="text-center text-xl font-bold ">This Feature is available on our Mobile app</h1>
                <div className="flex justify-center gap-20 mt-16">
                    <img src={googleapp} className="w-28" />
                    <img src={appleapp} className="w-28 " />
                </div>
            </MainBg>
        </>
    )
}
export default AppDownload;